import { categoryList } from "@/mocks/site";
import { eventList, type EventItem } from "@/mocks/events";

export function getCategoryName(key: string): string {
  const found = categoryList.find((item) => item.key === key);
  return found ? found.name : "其他";
}

export function getCategoryIcon(key: string): string {
  const found = categoryList.find((item) => item.key === key);
  return found ? found.icon : "ri-price-tag-3-line";
}

export function getEventById(id: string): EventItem | undefined {
  return eventList.find((item) => item.id === id);
}

export function getRelatedEvents(current: EventItem, limit = 3): EventItem[] {
  return eventList
    .filter((item) => item.id !== current.id)
    .sort((a, b) => {
      const aScore = a.category === current.category ? 1 : 0;
      const bScore = b.category === current.category ? 1 : 0;
      if (aScore !== bScore) return bScore - aScore;
      return b.heat - a.heat;
    })
    .slice(0, limit);
}

export function sortByUpdated(list: EventItem[]): EventItem[] {
  return [...list].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
}

export function formatDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export function formatShortDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]}.${parts[1]}.${parts[2]}`;
}